module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"CompletedWork":"Temps de résolution","ID":"ID","Title":"Titre"}}')
  delete Component.options._Ctor
}
